import React from 'react';
import { PageTitle } from '../../../components';
import { CareerIntro, CareerBenefits, CareerTasks, Faqs } from '../../../sections';
import { useTranslation } from 'react-i18next';


const CareerPage = () => {
    return (
        <>
            <PageTitle title={'Dołącz do nas'} page={'Kariera'} />

            <div className='career-page-wrapper'>
                <CareerIntro />
                <CareerBenefits />
                <CareerTasks />
                <Faqs />
            </div>
        </>
    );
};

export default CareerPage;